import { render, staticRenderFns } from "./CopyFrom.vue?vue&type=template&id=42f3c8f3&scoped=true&"
import script from "./CopyFrom.vue?vue&type=script&lang=js&"
export * from "./CopyFrom.vue?vue&type=script&lang=js&"
import style0 from "./CopyFrom.vue?vue&type=style&index=0&id=42f3c8f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f3c8f3",
  null
  
)

component.options.__file = "CopyFrom.vue"
export default component.exports